// removed by extract-text-webpack-plugin
module.exports = {"buttonsContainer":"_2tkq","divider":"_1NH0","confirm":"KChd"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccountForm/JoinAccountForm.scss
// module id = U4pD
// module chunks = 0